import React from "react";

interface ListProps<T> {
  data: T[];
  renderItem: (item: T, index: number) => React.ReactNode;
  horizontal?: boolean;
  className?: string;
  style?: React.CSSProperties;
  contentContainerStyle?: React.CSSProperties;
  gap?: string;
}

function List<T>({
  data,
  renderItem,
  horizontal = false,
  className = "",
  style = {},
  gap = "1rem",
  contentContainerStyle = {},
}: ListProps<T>) {
  return (
    <div
      className={`${horizontal ? "scrollbar-hide" : ""} ${className}`.trim()}
      style={{
        ...style,
        overflowX: horizontal ? "auto" : undefined,
        overflowY: !horizontal ? "auto" : undefined,
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: horizontal ? "row" : "column",
          gap,
          ...contentContainerStyle,
        }}
      >
        {data.map((item, index) => renderItem(item, index))}
      </div>
    </div>
  );
}

export default List;
